<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Scheduled Job</li>
    </ol>
  </nav>
  <div class="inner-box">
    <div class="row">
      <div class="col-md-6">
        <div class="report-box">
          <div class="row">
            <div class="col-md-auto p-0">
              <div class="icon-box" style="background-color: #96D1FE;">
                <svg aria-hidden="true" focusable="false" width="50px" data-prefix="fas" data-icon="tasks"
                     class="svg-inline--fa fa-tasks fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 512 512">
                  <path fill="currentColor"
                        d="M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"></path>
                </svg>

              </div>
            </div>
            <div class="col-md">
              <label><b>Generate Invoice</b></label><br>
              <label>This job is used to Generate Invoice For AccountOwner who do not have orders in processing status
                since quite long time</label><br>
              <span class="ml-1" style="float:right;"><button type="button" class="btn btn-orange"
                                                              (click)="scheduledJobFunction('generateInvoice')">Submit</button></span><br>
            </div>

          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="report-box">
          <div class="row">
            <div class="col-md-auto p-0">
              <div class="icon-box" style="background-color: #96D1FE;">
                <svg aria-hidden="true" focusable="false" width="50px" data-prefix="fas" data-icon="tasks"
                     class="svg-inline--fa fa-tasks fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 512 512">
                  <path fill="currentColor"
                        d="M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"></path>
                </svg>
              </div>
            </div>
            <div class="col-md">
              <label><b>Track Order</b></label><br>
              <label>This job is used to Purge End Customer who do not have orders in processing status since quite long
                time</label><br>
              <span class="ml-1" style="float:right;"><button type="button" class="btn btn-orange"
                                                              (click)="scheduledJobFunction('trackOrder')">Submit</button></span><br>
            </div>

          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="report-box">
          <div class="row">
            <div class="col-md-auto p-0">
              <div class="icon-box" style="background-color: #96D1FE;">
                <svg aria-hidden="true" focusable="false" width="50px" data-prefix="fas" data-icon="tasks"
                     class="svg-inline--fa fa-tasks fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 512 512">
                  <path fill="currentColor"
                        d="M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"></path>
                </svg>
              </div>
            </div>
            <div class="col-md">
              <label><b>Generate Channels Invoice</b></label><br>
              <label>This job is used to Generate Invoice from Channels</label><br>
              <span class="ml-1" style="float:right;"><button type="button" class="btn btn-orange"
                                                              (click)="getChannelsInvoices()">Submit</button></span><br>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>
